<template>
  <div>
    <job-menu :job="job"></job-menu>

    <div class="px-4 my-10">
      <div class="flex items-center justify-center">
        <h1 class="w-full mb-5 text-3xl font-bold text-center md:mb-0 md:w-auto">
          {{ __('Order notifications') }}
        </h1>
      </div>

      <div class="p-4 mt-10 bg-white shadow-md">
        <div class="max-w-5xl p-10 mx-auto">
          <div class="mb-10">
            <h3 class="text-xl font-bold">{{ __('Details') }}</h3>
            <div class="mt-4">
              <div class="mb-2">
                {{ request.user.name }} - {{ request.created_at }}
              </div>
              <div class="mb-2" v-if="request.responded_at">
                {{ __('Responded at') }}:{{ request.responded_at }}
              </div>
            </div>
          </div>

          <div class="mb-10">
            <h3 class="text-xl font-bold">{{ __('Client') }}</h3>
            <div class="mt-4">
              <div>
                {{ request.client.name }} - {{ request.client.phone }}
              </div>
            </div>
          </div>

          <div v-if="operations.length">
            <h3 class="text-xl font-bold">{{ __('Operations') }}</h3>

            <table class="w-full mt-4 border border-gray-600" aria-describedby="Job operations table">
              <tr class="text-left text-gray-100 bg-gray-700">
                <th id="operation-description" class="w-full p-2 min-w-48">{{ __('Description') }}</th>
                <th id="operation-price" class="p-2 text-right min-w-40">{{ __('Price') }}</th>
                <th id="operation-status" class="p-2 text-right min-w-40">{{ __('Status') }}</th>
              </tr>

              <tr v-for="(operation, index) in operations" :key="operation.id" :class="{'bg-gray-300': index%2 === 0}">
                <td class="px-2 py-4">
                  {{ operation.description }}
                </td>
                <td class="px-2 py-4 text-right">
                  {{ operation.price }}
                </td>
                <td class="px-2 py-4 text-right">
                  <span class="operation-status" :class="operation.status">{{ operation.status_label }}</span>
                </td>
              </tr>
            </table>
          </div>

          <div class="mt-10" v-if="mediaFiles.length">
            <h3 class="text-xl font-bold">{{ __('Media') }}</h3>

            <div class="flex flex-wrap mt-2 -mx-2">
              <label class="flex w-1/3 p-2 cursor-pointer" v-for="media in mediaFiles" :key="media.id">
                <div class="relative w-full">
                  <div class="absolute w-full h-full bg-black opacity-0 hover:opacity-25"></div>
                  <div class="absolute top-0 left-0 z-10 px-2 py-1 text-sm text-white bg-gray-500">{{ media.created_at }}</div>
                  <img v-if="media.collection_name === 'images'" :src="media.url" alt="" class="inset-0 object-contain w-full h-full bg-black"/>
                  <video v-if="media.collection_name === 'videos'" class="inset-0 object-contain w-full h-full bg-black" controls>
                    <source :src="media.url" type="video/webm">
                    <source :src="media.url_mp4" type="video/mp4">
                  </video>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Layout from '@/Shared/Layout';
import Icon from '@/Shared/Icon';
import Pagination from '@/Shared/Pagination';
import JobMenu from '../Jobs/JobMenu';

export default {
  layout: Layout,
  metaInfo() {
    return {
      title: this.__('Order notifications'),
    };
  },
  props: {
    job: Object,
    request: Object,
  },
  data() {
    return {
      operations: [],
      mediaFiles: [],
    };
  },
  mounted() {
    this.operations = this.request.operations;
    this.mediaFiles = this.request.media;
  },
  components: {
    Layout,
    Pagination,
    Icon,
    JobMenu,
  },
};
</script>
